import { Card, CardContent } from '@/components/ui/card';
import { Shield, Zap, TrendingDown, Leaf } from 'lucide-react';

export const WhyBESSSection = () => {
  const features = [
    {
      icon: Zap,
      title: 'Netzstabilität',
      description:
        'Puffert Lastspitzen ab und sichert eine konstante Stromversorgung auch bei Netzstörungen.',
      color: 'text-primary',
      bgColor: 'bg-primary/10',
    },
    {
      icon: Shield,
      title: 'Ausfallsicherheit',
      description:
        'Nahtlose Überbrückung bei Stromausfällen – kein Datenverlust, kein Serviceunterbruch.',
      color: 'text-accent',
      bgColor: 'bg-accent/10',
    },
    {
      icon: TrendingDown,
      title: 'Kostenreduktion',
      description:
        'Peak-Shaving und intelligentes Energiemanagement senken Betriebskosten erheblich.',
      color: 'text-secondary',
      bgColor: 'bg-secondary/10',
    },
    {
      icon: Leaf,
      title: 'Nachhaltigkeit',
      description:
        'Integration erneuerbarer Energien für einen grünen, CO₂-reduzierten Betrieb.',
      color: 'text-success',
      bgColor: 'bg-success/10',
    },
  ];

  return (
    <section id="why-bess" className="py-12 sm:py-20 bg-gradient-to-b from-background to-muted">
      <div className="container mx-auto px-4">
        {/* Header */}
        <div className="max-w-3xl mx-auto text-center mb-16">
          <p className="text-base sm:text-xl text-muted-foreground font-normal mb-2">
            Warum BESS:
          </p>
          <h2 className="font-heading font-bold text-2xl sm:text-4xl lg:text-5xl text-primary mb-6">
            Unverzichtbar für Rechenzentren
          </h2>
          <p className="text-lg text-muted-foreground leading-relaxed">
            Rechenzentren zählen zu den energieintensivsten Infrastrukturen
            weltweit. Ungeplante Ausfälle, schwankende Netzstabilität und
            steigende Stromkosten machen zuverlässige Energiespeicherlösungen
            zur strategischen Notwendigkeit.
          </p>
        </div>

        {/* Visual Image Row - show only last image on mobile, all 3 on desktop */}
        <div className="mb-14">
          <div className="hidden md:grid md:grid-cols-3 gap-6">
            <img
              src="https://customer-assets.emergentagent.com/job_462b1c9b-939c-4705-8ff2-b6f811719f70/artifacts/xljklrdx_graphic1.png"
              alt="Netzstabilisierung"
              className="w-full rounded-lg shadow-sm object-cover aspect-[4/3]"
              loading="lazy"
              data-testid="whybess-image-1"
            />
            <img
              src="https://customer-assets.emergentagent.com/job_462b1c9b-939c-4705-8ff2-b6f811719f70/artifacts/k2xbn341_graphic2.png"
              alt="Batterie-Module"
              className="w-full rounded-lg shadow-sm object-cover aspect-[4/3]"
              loading="lazy"
              data-testid="whybess-image-2"
            />
            <img
              src="https://customer-assets.emergentagent.com/job_462b1c9b-939c-4705-8ff2-b6f811719f70/artifacts/42395rga_graphic3.png"
              alt="Steuerungstechnik"
              className="w-full rounded-lg shadow-sm object-cover aspect-[4/3]"
              loading="lazy"
              data-testid="whybess-image-3"
            />
          </div>
          <div className="md:hidden">
            <img
              src="https://customer-assets.emergentagent.com/job_462b1c9b-939c-4705-8ff2-b6f811719f70/artifacts/42395rga_graphic3.png"
              alt="Steuerungstechnik"
              className="w-full rounded-lg shadow-sm object-cover aspect-[4/3]"
              loading="lazy"
            />
          </div>
        </div>

        {/* Features Grid */}
        <div className="grid grid-cols-1 md:grid-cols-2 lg:grid-cols-4 gap-6">
          {features.map((feature, index) => (
            <Card
              key={index}
              className="group hover:shadow-lg transition-all duration-300 border-border hover:border-primary/30 hover:-translate-y-2"
            >
              <CardContent className="p-6 flex flex-col h-full">
                {/* Icon */}
                <div
                  className={`w-14 h-14 rounded-xl ${feature.bgColor} flex items-center justify-center mb-4 group-hover:scale-110 transition-transform`}
                >
                  <feature.icon className={`w-7 h-7 ${feature.color}`} />
                </div>

                {/* Title */}
                <h3 className="font-heading font-semibold text-xl text-foreground mb-3">
                  {feature.title}
                </h3>

                {/* Description */}
                <p className="text-muted-foreground leading-relaxed">
                  {feature.description}
                </p>
              </CardContent>
            </Card>
          ))}
        </div>
      </div>
    </section>
  );
};